import Box from '@mui/material/Box'
import { styled, Theme } from '@mui/material/styles'
import Tabs from '@mui/material/Tabs'
import React from 'react'

import { useScrollToInitialHeight } from '@f-fertighaus/applications/Next/components/common/navigation/tabs/hooks/useScrollToInitialHeight'

const getCustomStyles = ({ theme }: { theme: Theme }) => ({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: theme.palette.text.primary
  }
})

interface TabsListProps {
  children: React.ReactNode
  activeTabIndex: number
  handleTabChange: (event: React.SyntheticEvent, index: number) => void
}

const StyledTabs = styled(
  ({ activeTabIndex, handleTabChange, ...rest }: TabsListProps) => {
    const tabsRef = React.useRef<HTMLButtonElement>(null)

    const handleClick = useScrollToInitialHeight(tabsRef)

    return (
      <Tabs
        {...rest}
        value={activeTabIndex}
        onChange={handleTabChange}
        onClick={handleClick}
        aria-label='house detail tabs'
        variant='scrollable'
        scrollButtons={false}
        TabIndicatorProps={{
          children: <span className='MuiTabs-indicatorSpan' />
        }}
        ref={tabsRef}
      />
    )
  }
)(getCustomStyles)

const StyledBox = styled(Box)`
  border-bottom: 1px;
  border-color: transparent;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  z-index: 11;
`

export const TabsList = ({
  children,
  activeTabIndex,
  handleTabChange
}: TabsListProps) => (
  <StyledBox>
    <StyledTabs
      activeTabIndex={activeTabIndex}
      handleTabChange={handleTabChange}>
      {children}
    </StyledTabs>
  </StyledBox>
)
